export default __webpack_public_path__ + "static/media/msf_m1.79b04f0c.png";